var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c(_vm.activeComponent,{tag:"component",on:{"action":_vm.onAction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }